import React, { useState, useEffect } from "react";
import "./Tourism.css";

const cardData = [
  {
    id: 1,
    title: "Marina Beach",
    description:
      "Marina Beach is one of the longest urban beaches in the world, offering a refreshing view of the Bay of Bengal. It is a popular spot for evening walks, picnics, and water sports.",
    images: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8lP_FmEM6nRXAE_-ohwBNXgSyln-elJ4l6mGhOR7fycmvfIFajBCevYqrjXI5vQ3wDVo&usqp=CAU",
      "https://imgcld.yatra.com/ytimages/image/upload/t_yt_blog_w_800_c_fill_g_auto_q_auto:good_f_jpg/v1437483460/Marina_Beach.jpg",
    ],
    points: [
      "Scenic beach view",
      "Walking track along the beach",
      "Perfect for evening hangouts",
    ],
  },
  {
    id: 2,
    title: "Kapaleeshwarar Temple",
    description:
      "The Kapaleeshwarar Temple is a famous Hindu temple dedicated to Lord Shiva, located in Mylapore. The temple's architecture is stunning, showcasing the grandeur of Dravidian style.",
    images: [
      "https://travelsetu.com/apps/uploads/new_destinations_photos/destination/2023/12/21/d5e6f1afee6178b111a4d9ab82170c3e_1000x1000.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTZ21EY8S-tmPs3BNmhiww5foy2sy-EUlYkrf9Y09fEP46Zw3KIcXQUeITs66zVSJArbAY&usqp=CAU",
    ],
    points: [
      "Historical architecture",
      "Religious significance",
      "Cultural hub",
    ],
  },
  {
    id: 3,
    title: "Fort St. George",
    description:
      "Fort St. George, the first English fortress in India, was built by the British in 1644. Today, it houses a museum and government offices, and offers a glimpse into Chennai's colonial past.",
    images: [
      "https://www.hoteldekho.com/storage/img/tourattraction/1644929820fort%20st.jpg",
      "https://cdn1.tripoto.com/media/filter/nl/img/2380291/Image/1707917309_fort_george.jpg.webp",
    ],
    points: [
      "Colonial history",
      "Fort and museum tours",
      "Panoramic views of the city",
    ],
  },
  {
    id: 4,
    title: "Santhome Cathedral",
    description:
      "Santhome Cathedral is a beautiful neo-gothic church located near the Marina Beach. It is believed to be the final resting place of St. Thomas the Apostle.",
    images: [
      "https://sun-b2b.s3.us-east-2.amazonaws.com/attraction/2021-10-08things11-43-02.jpg",
      "https://travelsetu.com/apps/uploads/new_destinations_photos/destination/2023/12/21/f2be0826fc1989b43afe0746a60f27bb_1000x1000.jpg",
    ],
    points: [
      "Historic church",
      "Religious significance",
      "Beautiful architecture",
    ],
  },
  {
    id: 5,
    title: "Government Museum",
    description:
      "The Government Museum in Chennai is one of the oldest museums in India, showcasing a vast collection of archaeological and numismatic items, as well as ancient art and sculptures.",
    images: [
      "https://www.tamilnadutourism.tn.gov.in/img/pages/large-desktop/government-museum-chennai-1657702610_11454259b542847c9b21.webp",
      "https://www.indiatravelblog.net/wp-content/uploads/2011/09/Government-Museum-of-Chennai.jpg",
    ],
    points: [
      "Archaeological and art collections",
      "Numismatic exhibits",
      "Educational experience",
    ],
  },
  {
  id: 6,
  title: "Mahabalipuram",
  description:
    "Mahabalipuram, a UNESCO World Heritage Site, is a historic coastal town in Tamil Nadu known for its ancient rock-cut temples, intricate stone carvings, and scenic beaches. It was a thriving port city during the Pallava dynasty.",
  images: [
    "https://images.unsplash.com/photo-1717417927851-d1c28e6afdbd?q=80&w=3270&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://images.unsplash.com/photo-1640715751438-7120b3019712?q=80&w=3292&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://images.unsplash.com/photo-1717417927851-d1c28e6afdbd?q=80&w=3270&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  ],
  points: [
    "UNESCO World Heritage Site",
    "Shore Temple and rock-cut monuments",
    "Historic and scenic coastal town"
  ],
}

];

const Tourism = () => {
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setImageIndex((prevIndex) => (prevIndex + 1) % cardData[0].images.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="ServicesCard-section py-5">
      <div className="container text-center">
        <h2 className="ServicesCard-title mt-2">Places To Visit In Chennai</h2>
        <p className="ServicesCard-subtitle mt-2">
          Discover the beauty of Chennai with these iconic tourist spots.
        </p>
        <div className="row justify-content-center align-items-start mt-5">
          {cardData.map((card) => (
            <div key={card.id} className="col-md-5 mx-3 mb-5 ServicesCard-card">
              <a href="" style={{ textDecoration: "none" }}>
                <div className="ServicesCard-image-container">
                  <img
                    src={card.images[imageIndex]}
                    alt={card.title}
                    className="img-fluid ServicesCard-image"
                  />
                </div>
                <div className="ServicesCard-content text-start p-4">
                  <h3 className="ServicesCard-subtitle-bold mt-2 zoom-effect">
                    {card.title.toUpperCase()}
                  </h3>

                  <p className="ServicesCard-text mt-3">{card.description}</p>
                  <ul className="ServicesCard-list mt-3">
                    {card.points.map((point, index) => (
                      <li key={index}>{point}</li>
                    ))}
                  </ul>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Tourism;
